// pages/agent/AgentEmployees.jsx
"use client"
import React from 'react'
import Navbar from '../../components/agent/common/Navbar'
import AgentEmployeesComponent from '../../components/agent/employees/AgentEmployeesComponent'

const AgentEmployees = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:pt-8 w-full">
     <AgentEmployeesComponent/>
    </main>
  </div>
  )
}

export default AgentEmployees